/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import cn from '../../../../utils/cn';
import { GetDateTime } from '../../../../utils/Show';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const [isTrActive, setIsTrActive] = useState(false);

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span className="line-clamp-1">{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.subscriptionId}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1 capitalize">
                        {GetDateTime(item?.timeCreated)}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard name="IP Info." value={item?.ip} className="sm:hidden" />
                <TableInfoCard name="User Agent" value={item?.userAgent} />
                <TableInfoCard name="Country" value={item?.country} />
                <TableInfoCard name="Date Created" value={GetDateTime(item?.timeCreated)} />
                <TableInfoCard name="Date Logged" value={GetDateTime(item?.timeLogged)} />
            </div>
        </div>
    );
}

function ExternalLogPageTableMobile({ data, handleReload }) {
    return (
        <div className="external_log_page_mobile_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => (
                        <TableRow key={item.id} item={item} handleReload={handleReload} />
                    ))
                )}
            </div>
        </div>
    );
}

export default ExternalLogPageTableMobile;
